import React, { Component } from 'react';
import QRCode from '../../../images/wechat-qrcode.jpg';
import './footer.css';

class FooterSocialConnect extends Component {
  constructor(props) {
    super(props);
  }

  getFooterSocialConnectHTML() {
    const items = this.props.data.items;
    let html = items.map((item, index) =>
      <a key={index} className={(item.alt === 'Wechat') ? "footer-wechat-share" : ""} href={item.href}><img loading='lazy' className="social-icon" src={item.src} alt={item.alt} /></a>
    );
    return (
      <div className="social-container">
        {html}
        {this.getWechatShareHTML()}
      </div>
    );
  }

  getWechatShareHTML() {
    return (
      <div className="wechat-share-tooltip">
        <div className="wechat-qrcode">
          <span className="wechat-title-label">微信扫一扫：分享</span>
          <div className="qrcode"><img src={QRCode} /></div>
          <div className="help"><p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p></div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <h6>{this.props.data.title}</h6>
          {this.getFooterSocialConnectHTML()}
        </div>
      </div>
    )
  }
}

export default FooterSocialConnect;